import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import { useHomeContext } from '../../context'
import { BenefitItem } from '../../../../components/ui/benefitItem'

const Benefits = () => {
  const { t, benefitKeys } = useHomeContext()

  return (
    <Box sx={{ position: 'relative', zIndex: 10, mt: 3 }}>
      <Typography
        component="h2"
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 600,
          fontSize: 16,
          color: '#141414',
          letterSpacing: '-0.32px',
          mb: 1.5,
        }}
      >
        {t('landing.whyJoin')}
      </Typography>

      <Stack spacing={1.5}>
        {benefitKeys.map((key) => (
          <BenefitItem
            key={key}
            title={t(`landing.benefits.${key}.title`)}
            description={t(`landing.benefits.${key}.description`)}
          />
        ))}
      </Stack>
    </Box>
  )
}

export default Benefits
